<template lang="pug">
  main
    NavBarAccesos
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns.has-text-centered
          .column.is-offset-one-quarter.is-half
            h3.title Búsqueda por Autotanque
              | &nbsp
              router-link.a.button.is-dark.is-rounded.is-size-6.is-medium(to="/IRGE/Accesos_IRGE")
                i.fas.fa-times
        .columns.has-text-centered
          .column.is-offset-4.is-4
            TypeaheadPG(:options="autotanques" :optionSelect="itemData" v-model="itemSel")
        .columns.has-text-centered
          .column.is-offset-3.is-6.has-text-centered(v-if="tanqueNoVisita === true")
            .notification
              | {{ searchQuery }}
          .column.is-offset-one-quarter.is-two-quarters.has-text-centered(v-else)
            table#tbBusqueda.table.is-striped.is-responsive(v-show="mostrarTable")
              thead
                tr
                  th
                    abbr(title='Número') Autotanque
                  th
                    abbr(title='Fecha y Hora') Entrada
                  th
                    abbr(title='Salida') Salida
                  th
                    abbr(title='Emplazado') Emplazado
              tbody
                tr(v-for="(data, index) in visitas" :key="data.id")
                  td
                    a.button.is-rounded(@click="mostrarEntrada(data)" :class="{'is-primary': isFinish(data.estado), 'is-danger': !isFinish(data.estado)}") {{ data.pg }}
                  td {{ data.fechaRecepcion }}
                  td {{ isInPlanta(data) }}
                  td 
                    a.button.is-rounded(:class="{'is-info': !isEmplazado(data.emplazado), 'is-danger': isEmplazado(data.emplazado)}") {{ data.emplazado | estToHtml }}
        .columns.column-blanco
</template>

<script>
import NavBarAccesos from '@/components/sca_Componentes/acceso/layout/NavBarAccesos.vue'
import Loader from '@/components/shared/Loader.vue'
import TypeaheadPG from '@/components/sca_Componentes/acceso/shared/TypeaheadPG.vue'
import autotanquesServicesIRGE from '@/services/irge/autotanquesIRGE.js'

export default {
  name: 'BusquedaPG',
  components: { Loader, TypeaheadPG, NavBarAccesos },
  data () {
    return {
      searchQuery: '',
      autotanques: [],
      autotanqueSelect: {},
      emplazadoStr: '',
      tanqueNoVisita: false,
      tanqueEmplazado: false,
      isLoading: true,
      itemData: {},
      itemSel: {},
      visitas: {},
      mostrarTable: false
    }
  },
  watch: {
    itemSel () {
      console.log(this.itemSel)
      this.selectPG(this.itemSel.id)
    }
  },
  methods: {
    iniciarComponente () {
      this.isLoading = false
      autotanquesServicesIRGE.searchPG_All()
        .then(res => {
          console.log(res)
          this.autotanques = res
        })
    },
    selectPG (id) {
      console.log(id)
      this.searchQuery = `Buscado Información de ${id} . . . `
      autotanquesServicesIRGE.searchRec_PG(id)
        .then(res => {
          console.log(res)
          this.visitas = res.reverse()
          if (this.visitas.length > 0) {
            this.mostrarTable = true
            this.tanqueNoVisita = false
            // if (this.autotanqueSelect[0].emplazado === '0') {
            //   console.log('Visita y No emplazado')
            //   this.searchQuery = `🚛 Autotanque ${id} | U. Visita: ${this.autotanqueSelect[0].fechaRecepcion}`
            //   this.tanqueNoVisita = false
            //   this.tanqueEmplazado = false
            // } else {
              // console.log('Visita y Emplazado')
              // this.searchQuery = `🚛 Autotanque ${id} | U. Visita: ${this.autotanqueSelect[0].fechaRecepcion}`
              // this.emplazadoStr = ` Emplazado: ${this.autotanqueSelect[0].fechaEmplazamiento}`
              // this.tanqueNoVisita = false
              // this.tanqueEmplazado = true
            // }
          } else {
            console.log('No visitado')
            this.searchQuery = `🚛 El Autotanque ${id} no tiene registrado algún acceso.`
            this.tanqueNoVisita = true
            this.tanqueEmplazado = false
          }
        })
    },
    mostrarEntrada (tanque) {
      this.isLoading = true
      this.$store.commit('autotanqueSalida', tanque)
      setTimeout(() => {
        this.isLoading = false
        this.$router.push({ path: '/TPA/SCA/Accesos/Salida' })
      }, 2000)
    },

    isFinish: function (finalizado) {
      if (finalizado === '0') {
        return false
      } else {
        return true
      }
    },
    isEmplazado: function (emplazado) {
        console.log(emplazado)
        if (emplazado === '0') {
          return false
        } else {
          return true
        }
      },
      isInPlanta (rec) {
        if (rec.estado === '1') {
          return rec.fechaSalida
        } else {
          return 'Aun Sigue en Planta'
        }
      },
  },
  created () {
    this.iniciarComponente()
  },
}
</script>

<style lang="css" scoped>
  .column-blanco {
    padding-bottom: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/components/sca_Componentes/acceso/BusquedaPG.vue